import {connect} from 'react-redux'
import {
  invoicesPageRequest,
  changeDateInvoices,
  changeOutletInvoices,
  changeStatusInvoices,
  listInvoiceRequest,
  receiptInvoicesRequest,
  hideReceiptInvoice,
  resendEmail,
  printReceiptInvoicePdf,
  showCancelInvoiceModal,
  showOldCancelInvoiceModal,
  exportInvoices,
  onClickRecordPayment,
  onCancelRecordPayment,
  setListInvoice
} from 'actions/reports/invoices'
import styles from './style.css'
import {currencyFormatter} from 'utils/formatter'
import ReceiptInvoices from './ReceiptInvoices'
import ReceiptButtonGroup from 'components/receipt/invoices/ButtonGroup/ReceiptButtonGroup'
import RecordPaymentModal from 'components/receipt/invoices/RecordPaymentModal/RecordPaymentModal'
import CancelInvoiceModal from 'components/receipt/refunds/CancelInvoiceModal'
import OldCancelInvoiceModal from 'components/receipt/refunds/OldCancelInvoiceModal'
import ReceiptInvoicesModal from './ReceiptInvoices/ReceiptInvoicesModal'
import moment from 'moment'
import {formValueSelector} from 'redux-form'
import ActionBar from './ActionBar'
import InfiniteScroll from 'react-infinite-scroller'
import NoDataAndLoading from 'components/NoDataAndLoading'
import {browserHistory} from 'react-router'
import {showPageLoadingSpinner} from 'actions/loadingSpinner'
import * as mpReportsInvoices from 'mixpanel/reports/invoices'

class Invoices extends React.Component {
  static INVOICE_STATUS = {
    'cancelled': 'Cancelled',
    'unpaid': 'Unpaid',
    'overdue': 'Overdue',
    'paid': 'Paid',
    'partially_paid': 'Partially Paid'
  }

  constructor (props) {
    super(props)
    this.state = {
      openRecordPayment: false,
      openRefundBreakdownModal: false,
      invoice: null,
      invoiceDetailOpened: false,
      isMobile: false,
      showModal: false
    }
  }

  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      this.props.dispatch(invoicesPageRequest())
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    let {invoices, receiptInvoices} = this.props.data.reports.invoices
    let {showLoadingSpinnerPage} = this.props.data.loadingSpinner

    return (
      <div className={'container-full-nosub ' + styles['invoice-report']} id='invoice-content'>
        <div className='container no-padding invoice-container'>
          <div className='mk-action-bar'>
            <div>
              <div className='col-sm-12 col-xs-12 col-md-11 col-lg-10 no-padding'>
                <ActionBar onChangeOutlet={this._onChangeOutlet}
                  onChangeDate={this._onChangeDate}
                  onChangeStatuses={this._onChangeStatuses}
                  onChangeKeyword={this._onSearch}
                />
              </div>
              <div className='col-md-1 col-lg-2 col-xs-2 col-sm-2 no-padding visible-md visible-lg'>
                <div className='pull-right'>
                  <a className='btn btn-primary btn-export'
                    onClick={this._onClickExportButton}>
                    Export
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className={styles['invoice-table']}>
            <div className={styles['mk-report-invoice']}>
              <div className={styles['row-invoice']}>
                <div className='col-sm-12 trans-1 no-padding' id='mk-col-left'>
                  <NoDataAndLoading
                    showLoadingSpinner={showLoadingSpinnerPage}
                    noDataToDisplay={invoices && invoices.length === 0}
                    title='No Data To Display'
                    description='' />
                  {invoices && invoices.length > 0 && <div className={`${styles['div-invoice-table']} ${showLoadingSpinnerPage ? styles['hide-table'] : ''}`}>
                    <table id='invoice-table' className={styles['table-header']}>
                      <thead>
                        <tr>
                          <th className='text-center'>Date</th>
                          <th className='visible-md visible-lg'>Invoice Number</th>
                          {this._showOutletColumn() && <th>Outlet</th>}
                          <th className>Customer Name</th>
                          <th>Status</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                    </table>
                    <div className={styles['table-content-wrapper']}>
                      <InfiniteScroll
                        pageStart={1}
                        loadMore={this._onReachBottom}
                        hasMore={this._hasMore()}
                        useWindow={false}
                        threshold={10}
                        initialLoad={false}>
                        <table className={styles['table-content']}>
                          <tbody id='invoice-table-tbody'>
                            {invoices.map((invoice, idx) => {
                              let boundRowClick = this._showReceiptInvoices.bind(this, invoice.id)
                              return (
                                <tr
                                  className={(receiptInvoices !== null && invoice.parent_payment_id === receiptInvoices.id) ? 'invoice-row selected' : 'invoice-row'}
                                  key={idx}
                                  onClick={boundRowClick}>
                                  <td className='text-center'>
                                    {this._dateFormatColumn(invoice)}
                                  </td>
                                  <td className='visible-md visible-lg'>{invoice.invoice_no}</td>
                                  {this._showOutletColumn() && <td className={styles['col-outlet']}>{invoice.outlet_name}</td>}
                                  <td>
                                    {invoice.customer_name}
                                    {!invoice.customer_name && invoice.customer_email}
                                  </td>
                                  <td className={styles['col-status']} dangerouslySetInnerHTML={{__html: invoice.status_formatter}} />
                                  <td>{invoice.is_refunded ? '(' + currencyFormatter(invoice.total_collected) + ')' : currencyFormatter(invoice.total_collected)}</td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </InfiniteScroll>
                    </div>
                  </div>
                }
                </div>
                {receiptInvoices !== null && !this.state.isMobile && this.state.invoiceDetailOpened &&
                <div className='col-sm-12 trans-1' id='mk-col-right'>
                  <ReceiptButtonGroup
                    clickResendButton={() => this._onClickResendButton(receiptInvoices.id)}
                    invoiceDetail={receiptInvoices}
                    onClickRecordPayment={this._onClickRecordPayment}
                    onClickPrintButton={() => this._showReceiptInvoicePdf(receiptInvoices.id)}
                    onCancelInvoice={
                      receiptInvoices.is_refund_breakdown
                      ? this._onClickCancelInvoiceRefundBreakdown
                      : this._onClickCancelInvoiceOldRefund
                    }
                  />
                  <div className={'mk-col-right-box'}>
                    <ReceiptInvoices invoiceDetail={receiptInvoices} />
                  </div>
                  <div className='mk-col-right-action-box bottom invoice-done'>
                    <button
                      className='btn btn-primary pull-right'
                      id='btn-close'
                      onClick={this._hideReceipt}>
                      Done
                    </button>
                  </div>
                </div>
                }
                {this.state.isMobile && receiptInvoices !== null &&
                  <ReceiptInvoicesModal
                    onClickDoneButton={this._hideReceipt}
                    _onClickResendButton={() => this._onClickResendButton(receiptInvoices.id)}
                    receiptInvoices={receiptInvoices}
                    _onClickRecordPayment={this._onClickRecordPayment}
                    _showReceiptInvoicePdf={() => this._showReceiptInvoicePdf(receiptInvoices.id)}
                    onCancelInvoice={
                      !receiptInvoices.is_refund_breakdown
                      ? this._onClickCancelInvoiceOldRefund
                      : this._onClickCancelInvoiceRefundBreakdown
                    }
                    show={this.state.showModal}
                    onHide={this._hideReceipt}
                    />
                }
              </div>
            </div>
          </div>
        </div>
        {receiptInvoices !== null &&
        <RecordPaymentModal
          closeRecordPaymentModal={this._onHideRecordPayment}
          onClickCancel={this._onHideRecordPayment}
        />}
        {receiptInvoices !== null &&
        <CancelInvoiceModal />
        }
        {receiptInvoices !== null && <OldCancelInvoiceModal />}
      </div>
    )
  }

  _onChangeOutlet = (outletIds = []) => {
    let {date: {startDate, endDate}, keyword, statuses} = this.props.search
    mpReportsInvoices.reportsInvoiceChangeFilter({
      outletIds,
      startDate,
      endDate,
      statuses
    })
    this.props.dispatch(changeOutletInvoices(outletIds, startDate, endDate, statuses, keyword))
  }

  _onChangeDate = ({startDate, endDate}) => {
    const {keyword, statuses, outlet} = this.props.search
    mpReportsInvoices.reportsInvoiceChangeFilter({
      outletIds: outlet,
      startDate,
      endDate,
      statuses
    })
    this.props.dispatch(changeDateInvoices(startDate, endDate, statuses, keyword))
  }

  _onChangeStatuses = (statuses) => {
    let {date: {startDate, endDate}, keyword, outlet} = this.props.search
    mpReportsInvoices.reportsInvoiceChangeFilter({
      outletIds: outlet,
      startDate,
      endDate,
      statuses
    })
    this.props.dispatch(changeStatusInvoices(statuses, startDate, endDate, keyword))
  }

  _onSearch = (keyword) => {
    // close right column
    const toggledClass = 'col-sm-12 col-md-6 col-xs-6'
    $('#mk-col-left, #mk-col-right').removeClass(toggledClass)
    $('#mk-col-left').addClass('col-sm-12')
    $('#mk-col-right').hide()

    let {date: {startDate, endDate}, statuses} = this.props.search
    let startDateFormatted = startDate.format('D/M/YYYY')
    let endDateFormatted = endDate.format('D/M/YYYY')
    const {dispatch} = this.props
    dispatch(setListInvoice(null))
    dispatch(showPageLoadingSpinner(true))
    dispatch(listInvoiceRequest({
      startDate: startDateFormatted, endDate: endDateFormatted, keyword, status: statuses, page: 1
    }))
  }

  _hideReceipt = () => {
    let isMobile = document.getElementsByClassName('visible-md')[0].offsetParent == null
    this.setState({
      invoice: null,
      invoiceDetailOpened: false,
      isMobile: isMobile,
      showModal: false
    })
    this.props.dispatch(hideReceiptInvoice(isMobile))
  }

  _onClickResendButton = (invoiceId) => {
    this.props.dispatch(resendEmail(invoiceId))
  }

  _onClickRecordPayment = () => {
    this.props.dispatch(onClickRecordPayment())
  }

  _onHideRecordPayment = () => {
    this.props.dispatch(onCancelRecordPayment())
  }

  _showReceiptInvoicePdf = (invoiceId) => {
    this.props.dispatch(printReceiptInvoicePdf(invoiceId))
  }

  _onClickCancelInvoiceRefundBreakdown = () => {
    this.props.dispatch(showCancelInvoiceModal())
  }

  _onClickCancelInvoiceOldRefund = () => {
    this.props.dispatch(showOldCancelInvoiceModal())
  }

  _onClickExportButton = () => {
    let {startDate, endDate} = this.props.search.date
    const outlet = this.props.search.outlet
    let statuses = this.props.search.statuses
    let keyword = this.props.search.keyword

    let query = {start: moment(startDate).format('D/M/Y'), end: moment(endDate).format('D/M/Y'), status: statuses, keyword: keyword}
    let dateLabel = startDate.isSame(endDate, 'days') ? moment(startDate).format('DD-MM-YYYY') : [moment(startDate).format('DD-MM-YYYY'), moment(endDate).format('DD-MM-YYYY')].join(' - ')
    let filename = 'Report Invoices - ' + dateLabel
    this.props.dispatch(exportInvoices(query, filename, outlet[0]))
  }

  _showReceiptInvoices = (invoice, event) => {
    let isMobile = document.getElementsByClassName('visible-md')[0].offsetParent == null
    this.setState({
      invoice: invoice,
      invoiceDetailOpened: !isMobile,
      isMobile: isMobile,
      showModal: isMobile
    })
    this.props.dispatch(receiptInvoicesRequest(invoice, isMobile))
  }

  _showOutletColumn = () => {
    const {search: {outlet}} = this.props
    return outlet && outlet.length > 1
  }

  /**
   *
   * @param {string} date from server
   * @private
   */
  _dateFormatColumn = (invoice) => {
    let today = new Date()
    let yesterday = new Date(new Date().setDate(new Date().getDate() - 1))
    let formattedToday = moment(today).format('DD/MM/YYYY')
    let formattedYesterday = moment(yesterday).format('DD/MM/YYYY')
    const invoiceDate = invoice.is_refunded ? invoice.refunded_date : invoice.created_at
    let formattedCreatedAt = moment(invoiceDate).format('DD/MM/YYYY')
    return formattedCreatedAt === formattedToday ? 'Today' : formattedCreatedAt === formattedYesterday ? 'Yesterday' : moment(invoice.created_at).format('DD MMM YYYY')
  }

  _onReachBottom = () => {
    let {currentPage, invoices} = this.props.data.reports.invoices
    let {startDate, endDate} = this.props.search.date
    let {keyword, statuses} = this.props.search
    this.props.dispatch(listInvoiceRequest({startDate: startDate, endDate: endDate, keyword, page: currentPage + 1, status: statuses}, invoices))
  }

  _hasMore = () => {
    let {currentPage, totalPage} = this.props.data.reports.invoices
    return currentPage < totalPage
  }
}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  // only fetch some state
  return {
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
      keyword: selector(state, 'keyword'),
      statuses: selector(state, 'statuses')
    },
    data: {
      category: state.category,
      reports: state.reports,
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired
    }
  }
}

export default connect(mapStateToProps)(Invoices)



// WEBPACK FOOTER //
// ./app/pages/Reports/Invoices/Invoices.js